<template>
  <div class="splash">
    <div class="img_splash_logo"><img src="/assets/img/splash/logo.png" alt=""></div>
    <div class="img_splash_001"><img src="/assets/img/splash/img_01.png" alt=""></div>
    <div class="img_splash_002"><img src="/assets/img/splash/img_02.png" alt=""></div>
    <div class="img_splash_003"><img src="/assets/img/splash/img_03.png" alt=""></div>
  </div>
</template>

<script>
export default {
  name: 'Splash',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
